import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 이 파일은 ReceivingPlannedManagement.tsx를 기반으로 쿠팡 출고관리용으로 생성된 페이지입니다.
// 마스터: coupang_Master, 디테일: coupang_Detail 테이블 구조에 맞게 컬럼/상태/함수명을 일부 수정해야 합니다.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Table, Modal, Card, Form, Row, Col } from 'react-bootstrap';
import { FaPrint, FaEdit, FaTrash, FaPlus, FaUpload, FaDownload, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { API_BASE_URL } from '../api/axiosConfig';
const CoupangOutboundManagement = () => {
    var _a;
    const [masters, setMasters] = useState([]);
    const [details, setDetails] = useState([]);
    const [selectedMaster, setSelectedMaster] = useState(null);
    const [showMasterModal, setShowMasterModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showPickingModal, setShowPickingModal] = useState(false);
    const [currentMaster, setCurrentMaster] = useState({});
    const [currentDetail, setCurrentDetail] = useState({});
    const [palletPickingData, setPalletPickingData] = useState(null);
    const [loading, setLoading] = useState(false);
    // 페이지네이션 상태 추가
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    useEffect(() => {
        fetchMasters();
    }, []);
    useEffect(() => {
        if (selectedMaster) {
            fetchDetails(selectedMaster.id);
        }
    }, [selectedMaster]);
    // 페이지네이션 계산 함수들
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentMasters = masters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(masters.length / itemsPerPage);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleItemsPerPageChange = (newItemsPerPage) => {
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1); // 페이지 크기가 변경되면 첫 페이지로 이동
    };
    const fetchMasters = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/coupang/masters`);
            if (response.data.success) {
                setMasters(response.data.data);
            }
        }
        catch (error) {
            console.error('Error fetching masters:', error);
        }
    };
    const fetchDetails = async (masterId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/coupang/details`, {
                params: { masterId }
            });
            if (response.data.success) {
                setDetails(response.data.data);
            }
        }
        catch (error) {
            console.error('Error fetching details:', error);
        }
    };
    const handlePalletPicking = async (masterId) => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/api/coupang/masters/${masterId}/pallet-picking`);
            if (response.data.success) {
                setPalletPickingData(response.data.data);
                setShowPickingModal(true);
            }
        }
        catch (error) {
            console.error('Error fetching pallet picking data:', error);
            alert('팔레트 피킹 리스트 조회에 실패했습니다.');
        }
        finally {
            setLoading(false);
        }
    };
    const handleMasterSubmit = async () => {
        var _a, _b, _c, _d;
        try {
            let response;
            if (currentMaster.id) {
                response = await axios.post(`${API_BASE_URL}/api/coupang/masters/${currentMaster.id}`, currentMaster);
            }
            else {
                response = await axios.post(`${API_BASE_URL}/api/coupang/masters`, currentMaster);
            }
            if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.success) === false) {
                throw new Error(response.data.message || '마스터 저장에 실패했습니다.');
            }
            alert(((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) || '마스터가 저장되었습니다.');
            handleMasterModalClose();
            await fetchMasters();
        }
        catch (error) {
            console.error('Error saving master:', error);
            const errorMessage = axios.isAxiosError(error)
                ? ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || error.message
                : error instanceof Error
                    ? error.message
                    : '마스터 저장 중 오류가 발생했습니다.';
            alert(errorMessage);
        }
    };
    const handleMasterModalClose = () => {
        setShowMasterModal(false);
        setCurrentMaster({});
    };
    const handleDetailSubmit = async () => {
        try {
            if (currentDetail.seq_id) {
                await axios.post(`${API_BASE_URL}/api/coupang/details/seq/${currentDetail.seq_id}`, currentDetail);
            }
            else if (currentDetail.id) {
                await axios.post(`${API_BASE_URL}/api/coupang/details/${currentDetail.id}`, currentDetail);
            }
            else {
                await axios.post(`${API_BASE_URL}/api/coupang/details`, {
                    ...currentDetail,
                    master_id: selectedMaster === null || selectedMaster === void 0 ? void 0 : selectedMaster.id
                });
            }
            setShowDetailModal(false);
            setCurrentDetail({});
            if (selectedMaster) {
                fetchDetails(selectedMaster.id);
            }
        }
        catch (error) {
            console.error('Error saving detail:', error);
            alert('저장 중 오류가 발생했습니다.');
        }
    };
    const handleDetailModalClose = () => {
        setShowDetailModal(false);
        setCurrentDetail({});
    };
    const handleDeleteMaster = async (id) => {
        if (window.confirm('정말로 삭제하시겠습니까?')) {
            try {
                await axios.get(`${API_BASE_URL}/api/coupang/masters/delete/${id}`);
                fetchMasters();
            }
            catch (error) {
                console.error('Error deleting master:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        }
    };
    const handleDeleteDetail = async (detail) => {
        if (window.confirm('정말로 삭제하시겠습니까?')) {
            try {
                if (detail.seq_id) {
                    await axios.post(`${API_BASE_URL}/api/coupang/details/seq/${detail.seq_id}/delete`, {
                        source_detail_id: detail.source_detail_id || null
                    });
                }
                else {
                    await axios.get(`${API_BASE_URL}/api/coupang/details/delete/${Number(detail.id)}`);
                }
                if (selectedMaster) {
                    fetchDetails(selectedMaster.id);
                }
            }
            catch (error) {
                console.error('Error deleting detail:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        }
    };
    const handlePrint = () => {
        if (!palletPickingData) {
            alert('팔레트 데이터가 없습니다.');
            return;
        }
        // 새 창에서 인쇄할 HTML 생성
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('팝업이 차단되었습니다. 팝업을 허용해주세요.');
            return;
        }
        const printHTML = generatePrintHTML(palletPickingData);
        printWindow.document.write(printHTML);
        printWindow.document.close();
        // 문서가 로드된 후 인쇄
        printWindow.onload = () => {
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        };
    };
    const handlePrintToPdf = () => {
        if (!palletPickingData) {
            alert('팔레트 데이터가 없습니다.');
            return;
        }
        // 새 창에서 PDF 저장
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('팝업이 차단되었습니다. 팝업을 허용해주세요.');
            return;
        }
        const printHTML = generatePrintHTML(palletPickingData);
        printWindow.document.write(printHTML);
        printWindow.document.close();
        // 문서가 로드된 후 PDF 저장 안내
        printWindow.onload = () => {
            setTimeout(() => {
                if (window.navigator.userAgent.includes('Chrome')) {
                    printWindow.print();
                }
                else {
                    alert('인쇄 다이얼로그에서 "PDF로 저장" 또는 "Microsoft Print to PDF"를 선택해주세요.');
                    printWindow.print();
                }
            }, 500);
        };
    };
    const generatePrintHTML = (data) => {
        const palletPagesHTML = data.pallets.map((pallet, index) => `
      <div class="pallet-page">
        <!-- 헤더 -->
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 22px; font-weight: bold; margin: 0;">
            쿠팡 파렛트 적재리스트
          </h2>
        </div>

        <!-- 팔레트 정보 -->
        <div style="border: 2px solid #000; padding: 15px; margin-bottom: 20px; text-align: center;">
          <h3 style="font-size: 25px; margin: 0 0 15px 0;">
            ${data.palletCount} - ${index + 1} / 박스수량 ( ${pallet.totalQty} BOX )
          </h3>
          
          <div style="font-size: 25px; line-height: 1.6;">
            <div>입고예정일자 ( ${formatDate(data.master.expected_date)} ) / 납품센터명 (${data.master.delivery_center})</div>
            <div>업체명 ( ${data.master.supplier_name} )</div>
            <div>입고요청서 번호 (${data.master.order_number})</div>
          </div>
        </div>

        <!-- 상품 목록 테이블 -->
        <table style="width: 100%; border: 2px solid #000; border-collapse: collapse;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #000; padding: 10px; text-align: center; width: 20%; font-size: 14px;">상품번호</th>
              <th style="border: 1px solid #000; padding: 10px; text-align: center; width: 50%; font-size: 14px;">상품명</th>
              <th style="border: 1px solid #000; padding: 10px; text-align: center; width: 15%; font-size: 14px;">BOX 수량</th>
              <th style="border: 1px solid #000; padding: 10px; text-align: center; width: 15%; font-size: 14px;">수량</th>
            </tr>
          </thead>
          <tbody>
            ${pallet.items.map(item => `
              <tr>
                <td style="border: 1px solid #000; padding: 10px; text-align: center; font-size: 14px;">${item.product_number}</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 14px;">${item.coupang_product_name}</td>
                <td style="border: 1px solid #000; padding: 10px; text-align: center; font-size: 14px;">${item.outgoing_qty}</td>
                <td style="border: 1px solid #000; padding: 10px; text-align: center; font-size: 14px;">${item.outgoing_qty}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `).join('');
        return `
      <!DOCTYPE html>
      <html lang="ko">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>쿠팡 팔레트 피킹 리스트</title>
        <style>
          @page {
            size: A4 landscape;
            margin: 15mm;
          }
          
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            background: white;
          }
          
          .pallet-page {
            page-break-after: always;
            page-break-inside: avoid;
            margin: 0;
            padding: 20px;
            width: 100%;
            height: auto;
            min-height: 200mm;
            border: 2px solid #000;
            background: white;
            box-sizing: border-box;
          }
          
          .pallet-page:last-child {
            page-break-after: auto;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          
          th, td {
            border: 1px solid #000;
            padding: 8px;
            font-size: 12px;
            text-align: center;
          }
          
          th {
            background-color: #f5f5f5;
            font-weight: bold;
          }
          
          h2 {
            font-size: 20px;
            margin: 0 0 20px 0;
            text-align: center;
          }
          
          h3 {
            font-size: 16px;
            margin: 0 0 15px 0;
          }
        </style>
      </head>
      <body>
        ${palletPagesHTML}
      </body>
      </html>
    `;
    };
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('ko-KR');
    };
    const downloadTemplate = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/coupang/template`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'coupang_detail_template.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error('Error downloading template:', error);
            alert('템플릿 다운로드에 실패했습니다.');
        }
    };
    const handleFileUpload = async (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        if (!selectedMaster) {
            alert('마스터를 먼저 선택해주세요.');
            return;
        }
        const formData = new FormData();
        formData.append('file', file);
        formData.append('masterId', selectedMaster.id.toString());
        try {
            const response = await fetch(`${API_BASE_URL}/api/coupang/upload-excel`, {
                method: 'POST',
                body: formData,
            });
            const result = await response.json();
            if (result.success) {
                alert(result.message);
                fetchDetails(selectedMaster.id);
            }
            else {
                alert(`업로드 실패: ${result.message}`);
                if (result.errors) {
                    console.error('Validation errors:', result.errors);
                }
            }
        }
        catch (error) {
            console.error('Upload error:', error);
            alert('업로드 중 오류가 발생했습니다.');
        }
        // 파일 입력 초기화
        event.target.value = '';
    };
    const handleOutboundOrder = async (masterId) => {
        try {
            setLoading(true);
            const response = await axios.post(`${API_BASE_URL}/api/coupang/masters/${masterId}/outbound-order`);
            if (response.data.success) {
                alert(response.data.message);
            }
            else {
                alert('출고지시 처리에 실패했습니다.');
            }
        }
        catch (error) {
            console.error('Error creating outbound order:', error);
            alert('출고지시 처리 중 오류가 발생했습니다.');
        }
        finally {
            setLoading(false);
        }
    };
    const handleOutboundOrderReport = async (masterId) => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/api/coupang/masters/${masterId}/outbound-order-list`);
            if (response.data.success) {
                const data = response.data.data;
                generateOutboundOrderExcel(data);
            }
            else {
                alert('출고지시서 데이터 조회에 실패했습니다.');
            }
        }
        catch (error) {
            console.error('Error fetching outbound order list:', error);
            alert('출고지시서 데이터 조회 중 오류가 발생했습니다.');
        }
        finally {
            setLoading(false);
        }
    };
    const handlePickingModalClose = () => {
        setShowPickingModal(false);
        setPalletPickingData(null);
    };
    const generateOutboundOrderExcel = (data) => {
        // 워크북 생성
        const wb = XLSX.utils.book_new();
        // 첫 번째 시트: 상세 픽킹 리스트
        const excelData = data.expandedItems.map((item, index) => ({
            '순번': index + 1,
            '상품코드': item.productCode,
            '상품명': item.productName,
            '택배사': item.courier,
            '수취인': item.recipientName,
            'A': item.locationA,
            'B': item.locationB,
            'C': item.locationC,
            '주문번호': item.orderNumber,
            '순서': `${item.itemSequence}/${item.totalSequence}`
        }));
        const ws1 = XLSX.utils.json_to_sheet(excelData);
        // 첫 번째 시트 컬럼 너비 설정
        ws1['!cols'] = [
            { wch: 8 },
            { wch: 15 },
            { wch: 30 },
            { wch: 10 },
            { wch: 15 },
            { wch: 12 },
            { wch: 12 },
            { wch: 12 },
            { wch: 20 },
            { wch: 10 } // 순서
        ];
        XLSX.utils.book_append_sheet(wb, ws1, '상세 픽킹리스트');
        // 두 번째 시트: 로케이션별 합계
        const locationSummaryData = data.locationSummary.map((item, index) => ({
            '순번': index + 1,
            '로케이션': item.location,
            'A': item.locationA,
            'B': item.locationB,
            'C': item.locationC,
            '상품코드': item.productCode,
            '상품명': item.productName,
            '갯수(합계)': item.count
        }));
        const ws2 = XLSX.utils.json_to_sheet(locationSummaryData);
        // 두 번째 시트 컬럼 너비 설정
        ws2['!cols'] = [
            { wch: 8 },
            { wch: 15 },
            { wch: 8 },
            { wch: 8 },
            { wch: 8 },
            { wch: 15 },
            { wch: 30 },
            { wch: 12 } // 갯수(합계)
        ];
        XLSX.utils.book_append_sheet(wb, ws2, '로케이션별 합계');
        // 엑셀 파일 다운로드
        const fileName = `쿠팡_출고지시서_${data.master.order_number}_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, fileName);
        alert(`출고지시서가 생성되었습니다.\n- 상세 픽킹리스트: ${data.expandedItems.length}개 항목\n- 로케이션별 합계: ${data.locationSummary.length}개 항목`);
    };
    return (_jsxs("div", { className: "container-fluid py-4", children: [_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-12 mb-4", children: _jsxs(Card, { className: "shadow-sm", children: [_jsx(Card.Header, { className: "bg-white py-3", children: _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsx("h5", { className: "mb-0", children: "\uCFE0\uD321 \uCD9C\uACE0 \uAD00\uB9AC" }), _jsxs("div", { children: [_jsxs(Button, { variant: "primary", onClick: () => {
                                                            setCurrentMaster({});
                                                            setShowMasterModal(true);
                                                        }, className: "me-2", children: [_jsx(FaPlus, { className: "me-1" }), "\uB9C8\uC2A4\uD130 \uB4F1\uB85D"] }), _jsxs(Button, { variant: "outline-secondary", onClick: downloadTemplate, children: [_jsx(FaDownload, { className: "me-1" }), "\uD15C\uD50C\uB9BF \uB2E4\uC6B4\uB85C\uB4DC"] })] })] }) }), _jsx(Card.Body, { children: _jsxs(Table, { responsive: true, hover: true, children: [_jsx("thead", { className: "table-light", children: _jsxs("tr", { children: [_jsx("th", { children: "\uC8FC\uBB38\uBC88\uD638" }), _jsx("th", { children: "\uC608\uC815\uC77C" }), _jsx("th", { children: "\uACF5\uAE09\uC5C5\uCCB4" }), _jsx("th", { children: "\uBC30\uC1A1\uC13C\uD130" }), _jsx("th", { children: "\uC8FC\uC694\uC0C1\uD488" }), _jsx("th", { children: "\uC791\uC5C5" })] }) }), _jsx("tbody", { children: currentMasters.map((master) => (_jsxs("tr", { onClick: () => setSelectedMaster(master), style: { cursor: 'pointer' }, className: (selectedMaster === null || selectedMaster === void 0 ? void 0 : selectedMaster.id) === master.id ? 'table-active selected-row' : '', children: [_jsx("td", { children: master.order_number }), _jsx("td", { children: formatDate(master.expected_date) }), _jsx("td", { children: master.supplier_name }), _jsx("td", { children: master.delivery_center }), _jsx("td", { children: master.main_product }), _jsxs("td", { children: [_jsxs(Button, { variant: "primary", size: "sm", onClick: (e) => {
                                                                        e.stopPropagation();
                                                                        handlePalletPicking(master.id);
                                                                    }, disabled: loading, className: "me-2", children: [_jsx(FaPrint, { className: "me-1" }), "\uD314\uB808\uD2B8 \uD53C\uD0B9 \uCD9C\uB825"] }), _jsxs(Button, { variant: "info", size: "sm", onClick: (e) => {
                                                                        e.stopPropagation();
                                                                        handleOutboundOrderReport(master.id);
                                                                    }, disabled: loading, className: "me-2", children: [_jsx(FaFileExcel, { className: "me-1" }), "\uCD9C\uACE0\uC9C0\uC2DC\uC11C \uCD9C\uB825"] }), _jsx(Button, { variant: "outline-primary", size: "sm", onClick: (e) => {
                                                                        e.stopPropagation();
                                                                        setCurrentMaster(master);
                                                                        setShowMasterModal(true);
                                                                    }, className: "me-2", children: _jsx(FaEdit, {}) }), _jsx(Button, { variant: "outline-danger", size: "sm", onClick: (e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteMaster(master.id);
                                                                    }, children: _jsx(FaTrash, {}) })] })] }, master.id))) })] }) }), _jsx(Card.Footer, { className: "bg-white border-top", children: _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsx("div", { className: "d-flex align-items-center", children: _jsxs("select", { className: "form-select form-select-sm me-3", style: {
                                                        width: 'auto',
                                                        minWidth: '120px',
                                                        border: '1px solid #dee2e6',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        fontSize: '14px'
                                                    }, value: itemsPerPage, onChange: (e) => handleItemsPerPageChange(Number(e.target.value)), children: [_jsx("option", { value: 5, children: "5\uAC1C\uC529 \uBCF4\uAE30" }), _jsx("option", { value: 10, children: "10\uAC1C\uC529 \uBCF4\uAE30" }), _jsx("option", { value: 20, children: "20\uAC1C\uC529 \uBCF4\uAE30" }), _jsx("option", { value: 50, children: "50\uAC1C\uC529 \uBCF4\uAE30" })] }) }), _jsx("nav", { "aria-label": "\uD398\uC774\uC9C0 \uB124\uBE44\uAC8C\uC774\uC158", children: _jsxs("ul", { className: "pagination pagination-sm mb-0", style: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }, children: [_jsx("li", { className: `page-item ${currentPage === 1 ? 'disabled' : ''}`, children: _jsx("button", { className: "page-link", onClick: () => handlePageChange(currentPage - 1), disabled: currentPage === 1, style: {
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '4px',
                                                                    marginRight: '4px',
                                                                    padding: '6px 12px',
                                                                    fontSize: '14px',
                                                                    backgroundColor: 'white',
                                                                    color: currentPage === 1 ? '#6c757d' : '#495057',
                                                                    display: 'inline-block'
                                                                }, children: "\uC774\uC804" }) }), (() => {
                                                            const pages = [];
                                                            const maxVisiblePages = 5;
                                                            if (totalPages <= maxVisiblePages) {
                                                                // 전체 페이지가 5개 이하면 모두 표시
                                                                for (let i = 1; i <= totalPages; i++) {
                                                                    pages.push(i);
                                                                }
                                                            }
                                                            else {
                                                                // 현재 페이지 기준으로 5개 페이지 표시
                                                                let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                                                                let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                                                                // 끝 페이지가 totalPages에 가까우면 시작 페이지 조정
                                                                if (endPage - startPage < maxVisiblePages - 1) {
                                                                    startPage = Math.max(1, endPage - maxVisiblePages + 1);
                                                                }
                                                                for (let i = startPage; i <= endPage; i++) {
                                                                    pages.push(i);
                                                                }
                                                            }
                                                            return pages.map((pageNumber) => (_jsx("li", { className: `page-item ${currentPage === pageNumber ? 'active' : ''}`, style: { display: 'inline-block' }, children: _jsx("button", { className: "page-link", onClick: () => handlePageChange(pageNumber), style: {
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '4px',
                                                                        margin: '0 2px',
                                                                        padding: '6px 12px',
                                                                        fontSize: '14px',
                                                                        minWidth: '40px',
                                                                        backgroundColor: currentPage === pageNumber ? '#007bff' : 'white',
                                                                        color: currentPage === pageNumber ? 'white' : '#495057',
                                                                        display: 'inline-block'
                                                                    }, children: pageNumber }) }, pageNumber)));
                                                        })(), _jsx("li", { className: `page-item ${currentPage === totalPages ? 'disabled' : ''}`, children: _jsx("button", { className: "page-link", onClick: () => handlePageChange(currentPage + 1), disabled: currentPage === totalPages, style: {
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '4px',
                                                                    marginLeft: '4px',
                                                                    padding: '6px 12px',
                                                                    fontSize: '14px',
                                                                    backgroundColor: 'white',
                                                                    color: currentPage === totalPages ? '#6c757d' : '#495057',
                                                                    display: 'inline-block'
                                                                }, children: "\uB2E4\uC74C" }) })] }) }), _jsxs("div", { className: "text-muted", style: { fontSize: '14px' }, children: ["\uCD1D ", masters.length, "\uAC1C \uC911 ", masters.length > 0 ? `${indexOfFirstItem + 1}-${Math.min(indexOfLastItem, masters.length)}개` : '0개'] })] }) })] }) }), selectedMaster && (_jsx("div", { className: "col-12", children: _jsxs(Card, { className: "shadow-sm", children: [_jsx(Card.Header, { className: "bg-white py-3", children: _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsxs("h6", { className: "mb-0", children: ["\uC0C1\uC138 \uC815\uBCF4 (", selectedMaster.order_number, ")"] }), _jsxs("div", { children: [_jsxs(Button, { variant: "primary", size: "sm", onClick: () => {
                                                            setCurrentDetail({});
                                                            setShowDetailModal(true);
                                                        }, className: "me-2", children: [_jsx(FaPlus, { className: "me-1" }), "\uC0C1\uC138 \uB4F1\uB85D"] }), _jsxs(Button, { variant: "info", size: "sm", onClick: downloadTemplate, className: "me-2", children: [_jsx(FaDownload, { className: "me-1" }), "\uC5D1\uC140 \uC591\uC2DD \uB2E4\uC6B4\uB85C\uB4DC"] }), _jsxs("label", { className: "btn btn-warning btn-sm", children: [_jsx(FaUpload, { className: "me-1" }), "\uC5D1\uC140 \uC5C5\uB85C\uB4DC", _jsx("input", { type: "file", accept: ".xlsx,.xls", onChange: handleFileUpload, className: "d-none" })] })] })] }) }), _jsx(Card.Body, { children: _jsxs(Table, { responsive: true, hover: true, size: "sm", children: [_jsx("thead", { className: "table-light", children: _jsxs("tr", { children: [_jsx("th", { children: "\uC0C1\uD488\uCF54\uB4DC" }), _jsx("th", { children: "\uC0C1\uD488\uBA85" }), _jsx("th", { children: "\uC0C1\uD488\uBC88\uD638" }), _jsx("th", { children: "\uCFE0\uD321\uC0C1\uD488\uBA85" }), _jsx("th", { children: "\uCD9C\uACE0\uC218\uB7C9" }), _jsx("th", { children: "\uD30C\uB808\uD2B8\uC218\uB7C9" }), _jsx("th", { children: "\uD30C\uB808\uD2B8\uC801\uC7AC\uC218\uB7C9" }), _jsx("th", { children: "\uB799" }), _jsx("th", { children: "\uCE35" }), _jsx("th", { children: "\uCE78" }), _jsx("th", { children: "\uAC00\uB85C" }), _jsx("th", { children: "\uC138\uB85C" }), _jsx("th", { children: "\uB192\uC774" }), _jsx("th", { children: "\uBB34\uAC8C" }), _jsx("th", { children: "\uBC14\uCF54\uB4DC" }), _jsx("th", { children: "\uC0C1\uD488\uBC14\uCF54\uB4DC" }), _jsx("th", { children: "\uD314\uB808\uD2B8\uBC88\uD638" }), _jsx("th", { children: "\uC791\uC5C5" })] }) }), _jsx("tbody", { children: details.map((detail, detailIndex) => (_jsxs("tr", { children: [_jsx("td", { children: detail.product_code }), _jsx("td", { children: detail.product_name }), _jsx("td", { children: detail.product_number }), _jsx("td", { children: detail.coupang_product_name }), _jsx("td", { className: "text-center", children: detail.outgoing_qty }), _jsx("td", { className: "text-center", children: detail.pallet_qty }), _jsx("td", { className: "text-center", children: detail.pallet_capacity }), _jsx("td", { className: "text-center", children: detail.rack }), _jsx("td", { className: "text-center", children: detail.level }), _jsx("td", { className: "text-center", children: detail.bin }), _jsx("td", { className: "text-center", children: detail.width }), _jsx("td", { className: "text-center", children: detail.depth }), _jsx("td", { className: "text-center", children: detail.height }), _jsx("td", { className: "text-center", children: detail.weight }), _jsx("td", { children: detail.barcode }), _jsx("td", { children: detail.product_barcode }), _jsx("td", { className: "text-center", children: detail.pallet_number }), _jsxs("td", { children: [_jsx(Button, { variant: "outline-primary", size: "sm", onClick: () => {
                                                                        setCurrentDetail(detail);
                                                                        setShowDetailModal(true);
                                                                    }, className: "me-2", children: _jsx(FaEdit, {}) }), _jsx(Button, { variant: "outline-danger", size: "sm", onClick: () => handleDeleteDetail(detail), className: "me-2", children: _jsx(FaTrash, {}) }), detail.seq_id ? (_jsx("span", { className: "text-muted", style: { fontSize: '12px' }, children: "SEQ" })) : null] })] }, `${detail.id}-${detailIndex}`))) })] }) })] }) }))] }), _jsxs(Modal, { show: showMasterModal, onHide: handleMasterModalClose, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: currentMaster.id ? '마스터 수정' : '마스터 등록' }) }), _jsx(Modal.Body, { children: _jsxs(Form, { children: [_jsxs(Row, { children: [_jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC8FC\uBB38\uBC88\uD638" }), _jsx(Form.Control, { type: "text", value: currentMaster.order_number || '', onChange: (e) => setCurrentMaster({ ...currentMaster, order_number: e.target.value }) })] }) }), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC608\uC815\uC77C" }), _jsx(Form.Control, { type: "date", value: ((_a = currentMaster.expected_date) === null || _a === void 0 ? void 0 : _a.split('T')[0]) || '', onChange: (e) => setCurrentMaster({ ...currentMaster, expected_date: e.target.value }) })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uACF5\uAE09\uC5C5\uCCB4" }), _jsx(Form.Control, { type: "text", value: currentMaster.supplier_name || '', onChange: (e) => setCurrentMaster({ ...currentMaster, supplier_name: e.target.value }) })] }) }), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uBC30\uC1A1\uC13C\uD130" }), _jsx(Form.Control, { type: "text", value: currentMaster.delivery_center || '', onChange: (e) => setCurrentMaster({ ...currentMaster, delivery_center: e.target.value }) })] }) })] }), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC8FC\uC694\uC0C1\uD488" }), _jsx(Form.Control, { type: "text", value: currentMaster.main_product || '', onChange: (e) => setCurrentMaster({ ...currentMaster, main_product: e.target.value }) })] })] }) }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleMasterModalClose, children: "\uCDE8\uC18C" }), _jsx(Button, { variant: "primary", onClick: handleMasterSubmit, children: "\uC800\uC7A5" })] })] }), _jsxs(Modal, { show: showDetailModal, onHide: handleDetailModalClose, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: currentDetail.id ? '상세 수정' : '상세 등록' }) }), _jsx(Modal.Body, { children: _jsxs(Form, { children: [_jsxs(Row, { children: [_jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC0C1\uD488\uCF54\uB4DC" }), _jsx(Form.Control, { type: "text", value: currentDetail.product_code || '', onChange: (e) => setCurrentDetail({ ...currentDetail, product_code: e.target.value }) })] }) }), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC0C1\uD488\uBA85" }), _jsx(Form.Control, { type: "text", value: currentDetail.product_name || '', onChange: (e) => setCurrentDetail({ ...currentDetail, product_name: e.target.value }) })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC0C1\uD488\uBC88\uD638" }), _jsx(Form.Control, { type: "text", value: currentDetail.product_number || '', onChange: (e) => setCurrentDetail({ ...currentDetail, product_number: e.target.value }) })] }) }), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uCFE0\uD321\uC0C1\uD488\uBA85" }), _jsx(Form.Control, { type: "text", value: currentDetail.coupang_product_name || '', onChange: (e) => setCurrentDetail({ ...currentDetail, coupang_product_name: e.target.value }) })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uCD9C\uACE0\uC218\uB7C9" }), _jsx(Form.Control, { type: "number", value: currentDetail.outgoing_qty || '', onChange: (e) => setCurrentDetail({ ...currentDetail, outgoing_qty: Number(e.target.value) }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uD314\uB808\uD2B8\uC218\uB7C9" }), _jsx(Form.Control, { type: "number", value: currentDetail.pallet_qty || '', onChange: (e) => setCurrentDetail({ ...currentDetail, pallet_qty: Number(e.target.value) }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uD30C\uB808\uD2B8\uC801\uC7AC\uC218\uB7C9" }), _jsx(Form.Control, { type: "number", value: currentDetail.pallet_capacity || '', onChange: (e) => setCurrentDetail({ ...currentDetail, pallet_capacity: Number(e.target.value) }) })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uB799" }), _jsx(Form.Control, { type: "text", value: currentDetail.rack || '', onChange: (e) => setCurrentDetail({ ...currentDetail, rack: e.target.value }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uB808\uBCA8" }), _jsx(Form.Control, { type: "text", value: currentDetail.level || '', onChange: (e) => setCurrentDetail({ ...currentDetail, level: e.target.value }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uBE48" }), _jsx(Form.Control, { type: "text", value: currentDetail.bin || '', onChange: (e) => setCurrentDetail({ ...currentDetail, bin: e.target.value }) })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uAC00\uB85C" }), _jsx(Form.Control, { type: "number", value: currentDetail.width || '', onChange: (e) => setCurrentDetail({ ...currentDetail, width: Number(e.target.value) }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC138\uB85C" }), _jsx(Form.Control, { type: "number", value: currentDetail.depth || '', onChange: (e) => setCurrentDetail({ ...currentDetail, depth: Number(e.target.value) }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uB192\uC774" }), _jsx(Form.Control, { type: "number", value: currentDetail.height || '', onChange: (e) => setCurrentDetail({ ...currentDetail, height: Number(e.target.value) }) })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uBB34\uAC8C" }), _jsx(Form.Control, { type: "number", value: currentDetail.weight || '', onChange: (e) => setCurrentDetail({ ...currentDetail, weight: Number(e.target.value) }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uBC14\uCF54\uB4DC" }), _jsx(Form.Control, { type: "text", value: currentDetail.barcode || '', onChange: (e) => setCurrentDetail({ ...currentDetail, barcode: e.target.value }) })] }) }), _jsx(Col, { md: 4, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uC0C1\uD488\uBC14\uCF54\uB4DC" }), _jsx(Form.Control, { type: "text", value: currentDetail.product_barcode || '', onChange: (e) => setCurrentDetail({ ...currentDetail, product_barcode: e.target.value }) })] }) })] }), _jsx(Row, { children: _jsx(Col, { md: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "\uD314\uB808\uD2B8\uBC88\uD638" }), _jsx(Form.Control, { type: "text", value: currentDetail.pallet_number || '', onChange: (e) => setCurrentDetail({ ...currentDetail, pallet_number: e.target.value }) })] }) }) })] }) }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleDetailModalClose, children: "\uCDE8\uC18C" }), _jsx(Button, { variant: "primary", onClick: handleDetailSubmit, children: "\uC800\uC7A5" })] })] }), _jsxs(Modal, { show: showPickingModal, onHide: handlePickingModalClose, size: "xl", centered: true, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: "\uD314\uB808\uD2B8 \uD53C\uD0B9 \uB9AC\uC2A4\uD2B8" }) }), _jsx(Modal.Body, { className: "print-modal-body", children: palletPickingData && (_jsx("div", { className: "pallet-picking-container", children: palletPickingData.pallets.map((pallet, index) => (_jsxs("div", { className: "pallet-page", style: {
                                    pageBreakAfter: index < palletPickingData.pallets.length - 1 ? 'always' : 'auto',
                                    minHeight: '210mm',
                                    width: '297mm',
                                    padding: '15px',
                                    border: '2px solid #000',
                                    margin: '10px 0',
                                    backgroundColor: 'white',
                                    boxSizing: 'border-box',
                                    display: 'block',
                                    position: 'relative'
                                }, children: [_jsx("div", { style: { textAlign: 'center', marginBottom: '20px' }, children: _jsx("h2", { style: { fontSize: '22px', fontWeight: 'bold', margin: '0' }, children: "\uCFE0\uD321 \uD30C\uB81B\uD2B8 \uC801\uC7AC\uB9AC\uC2A4\uD2B8" }) }), _jsxs("div", { style: {
                                            border: '2px solid #000',
                                            padding: '15px',
                                            marginBottom: '20px',
                                            textAlign: 'center'
                                        }, children: [_jsxs("h3", { style: { fontSize: '20px', margin: '0 0 20px 0' }, children: [palletPickingData.palletCount, " -", index + 1, " / \uBC15\uC2A4\uC218\uB7C9 ( ", pallet.totalQty, " BOX )"] }), _jsxs("div", { style: { fontSize: '14px', lineHeight: '1.6' }, children: [_jsxs("div", { children: ["\uC785\uACE0\uC608\uC815\uC77C\uC790 ( ", formatDate(palletPickingData.master.expected_date), " ) / \uB0A9\uD488\uC13C\uD130\uBA85 (", palletPickingData.master.delivery_center, ")"] }), _jsxs("div", { children: ["\uC5C5\uCCB4\uBA85 ( ", palletPickingData.master.supplier_name, " )"] }), _jsxs("div", { children: ["\uC785\uACE0\uC694\uCCAD\uC11C \uBC88\uD638 (", palletPickingData.master.order_number, ")"] })] })] }), _jsxs("table", { style: {
                                            width: '100%',
                                            border: '2px solid #000',
                                            borderCollapse: 'collapse'
                                        }, children: [_jsx("thead", { children: _jsxs("tr", { style: { backgroundColor: '#f5f5f5' }, children: [_jsx("th", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                width: '20%',
                                                                fontSize: '14px'
                                                            }, children: "\uC0C1\uD488\uBC88\uD638" }), _jsx("th", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                width: '50%',
                                                                fontSize: '14px'
                                                            }, children: "\uC0C1\uD488\uBA85" }), _jsx("th", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                width: '15%',
                                                                fontSize: '14px'
                                                            }, children: "BOX \uC218\uB7C9" }), _jsx("th", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                width: '15%',
                                                                fontSize: '14px'
                                                            }, children: "\uC218\uB7C9" })] }) }), _jsx("tbody", { children: pallet.items.map((item, itemIndex) => (_jsxs("tr", { children: [_jsx("td", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                fontSize: '14px'
                                                            }, children: item.product_number }), _jsx("td", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                fontSize: '14px'
                                                            }, children: item.coupang_product_name }), _jsx("td", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                fontSize: '14px'
                                                            }, children: item.outgoing_qty }), _jsx("td", { style: {
                                                                border: '1px solid #000',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                fontSize: '14px'
                                                            }, children: item.outgoing_qty })] }, itemIndex))) })] })] }, pallet.palletNumber))) })) }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handlePickingModalClose, children: "\uB2EB\uAE30" }), _jsxs(Button, { variant: "success", onClick: handlePrintToPdf, className: "me-2", children: [_jsx(FaFilePdf, { className: "me-1" }), "PDF \uC800\uC7A5"] }), _jsxs(Button, { variant: "primary", onClick: handlePrint, children: [_jsx(FaPrint, { className: "me-1" }), "\uC778\uC1C4"] })] })] }), _jsx("style", { children: `
        .print-modal-body {
          max-height: 80vh;
          overflow-y: auto;
        }
        
        /* 선택된 행 스타일링 */
        .table tbody tr.selected-row {
          background-color: #e3f2fd !important;
          border-left: 4px solid #2196f3;
        }
        
        .table tbody tr.selected-row:hover {
          background-color: #bbdefb !important;
        }
        
        .table tbody tr:hover:not(.selected-row) {
          background-color: #f8f9fa;
        }
        
        .table tbody tr {
          transition: background-color 0.2s ease;
        }
        
        /* 페이지네이션 스타일링 */
        .pagination {
          display: flex !important;
          flex-direction: row !important;
          align-items: center;
          gap: 4px;
          margin: 0;
          padding: 0;
          list-style: none;
        }
        
        .pagination .page-item {
          display: inline-block !important;
          margin: 0;
        }
        
        .pagination .page-link {
          color: #495057;
          background-color: white;
          border: 1px solid #dee2e6;
          transition: all 0.15s ease;
          font-weight: 400;
          display: inline-block !important;
          text-decoration: none;
        }
        
        .pagination .page-link:hover {
          color: #495057;
          background-color: #e9ecef;
          border-color: #dee2e6;
          transform: none;
          box-shadow: none;
        }
        
        .pagination .page-item.active .page-link {
          background-color: #007bff;
          border-color: #007bff;
          color: white;
          font-weight: 400;
        }
        
        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          background-color: white;
          border-color: #dee2e6;
          opacity: 0.6;
        }
        
        .pagination .page-link:focus {
          box-shadow: none;
          outline: none;
        }
        
        /* 선택 박스 스타일링 */
        .form-select-sm {
          border-radius: 4px;
          border: 1px solid #dee2e6;
          transition: border-color 0.15s ease-in-out;
        }
        
        .form-select-sm:focus {
          border-color: #80bdff;
          box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.25);
        }
      ` })] }));
};
export default CoupangOutboundManagement;
